<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    provide(){
      return{
        reload:this.reload
      }
    },
    data(){
      return{
        isRouterAlive:true
      }
    },
      mounted() {
          // 添加页面关闭/刷新监听
          window.addEventListener('beforeunload', this.handleBeforeUnload);
      },

      beforeDestroy() {
          // 移除事件监听
          window.removeEventListener('beforeunload', this.handleBeforeUnload);

      },
    methods:{
        handleBeforeUnload(event) {
            // 清理缓存
            // 可选：显示确认关闭的提示（现代浏览器可能限制自定义消息）
            // event.preventDefault();
            // event.returnValue = '确定要离开吗？未保存的数据可能会丢失。';
        },
      reload(){
        this.isRouterAlive=false;
        this.$nextTick(function(){
          this.isRouterAlive=true
          this.usertel='';
          this.password='';
          this.smsCode='';
          this.verifyCode='';
        })
      }
    }
  }
</script>


<style>
  /*@import "/src/common/font/font.css";*/
  #app {
    font-family:"PingFang SC";
    font-weight: 500;
    height: 100%
  }
</style>



// WEBPACK FOOTER //
// src/App.vue